import React from 'react';
import { formatVoiceDuration } from '../../utils/supportVoice';
import SupportVoicePlayer from './SupportVoicePlayer';

interface LiveProps {
  mode: 'recording' | 'requesting';
  durationSec: number;
  liveBars: number[];
  onCancel: () => void;
  onStop: () => void;
}

interface PreviewProps {
  mode: 'preview';
  previewUrl: string;
  durationSec: number;
  onDiscard: () => void;
  onSend: () => void;
  sending?: boolean;
}

type Props = LiveProps | PreviewProps;

const SupportVoiceRecorderBar: React.FC<Props> = (props) => {
  if (props.mode === 'preview') {
    return (
      <div className="sc-voice-recorder sc-voice-recorder--preview">
        <SupportVoicePlayer
          src={props.previewUrl}
          durationSec={props.durationSec}
          variant="user"
          compact
          seed={props.previewUrl}
        />
        <div className="sc-voice-recorder__actions">
          <button
            type="button"
            className="sc-voice-recorder__btn sc-voice-recorder__btn--ghost"
            onClick={props.onDiscard}
            aria-label="Удалить запись"
            title="Удалить"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            </svg>
          </button>
          <button
            type="button"
            className="sc-voice-recorder__btn sc-voice-recorder__btn--send"
            onClick={props.onSend}
            disabled={props.sending}
            aria-label="Отправить голосовое"
            title="Отправить"
          >
            {props.sending ? (
              <span className="sc-send-spinner" aria-hidden="true" />
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <line x1="22" y1="2" x2="11" y2="13" />
                <polygon points="22 2 15 22 11 13 2 9 22 2" />
              </svg>
            )}
          </button>
        </div>
      </div>
    );
  }

  const isRequesting = props.mode === 'requesting';

  return (
    <div className="sc-voice-recorder sc-voice-recorder--live">
      <button
        type="button"
        className="sc-voice-recorder__btn sc-voice-recorder__btn--ghost"
        onClick={props.onCancel}
        aria-label="Отменить запись"
        title="Отмена"
        disabled={isRequesting}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>

      <div className="sc-voice-recorder__live">
        <span className="sc-voice-recorder__dot" aria-hidden="true" />
        <span className="sc-voice-recorder__timer">
          {isRequesting ? 'Микрофон…' : formatVoiceDuration(props.durationSec)}
        </span>
        <div className="sc-voice-recorder__wave-live" aria-hidden="true">
          {props.liveBars.map((h, i) => (
            <span
              key={i}
              className="sc-voice-recorder__bar"
              style={{ '--bar-h': `${Math.round(h * 100)}%` } as React.CSSProperties}
            />
          ))}
        </div>
      </div>

      <button
        type="button"
        className="sc-voice-recorder__btn sc-voice-recorder__btn--stop"
        onClick={props.onStop}
        disabled={isRequesting}
        aria-label="Остановить запись"
        title="Готово"
      >
        <span className="sc-voice-recorder__stop-icon" aria-hidden="true" />
      </button>
    </div>
  );
};

export default SupportVoiceRecorderBar;
